import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const VIDEO_API = "/video";

// ----------------------- STATE ------------------------- //
const state = {
    video_data: [],
    video_devices:[
        {
            id: "18ba8230-f660-498b-843e-48c71b5f0442",
            name:"Vehicle - KBS 131B",
            vehicle_id: "18ba8230-f660-498b-843e-48c71b5f0442",
            channelCount: 2,
        },
        {
            id:"f6344534-525f-4e09-9e6d-d8b40f91fb90",
            name:"Vehicle - KBV 292H",
            vehicle_id: "f6344534-525f-4e09-9e6d-d8b40f91fb90",
            channelCount: 2,
        }
    ],
    currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
    getVideo: state => getField(state.video_data[state.currentIndex]),

    getCurrentVideo: state => {
        return state.video_data[state.currentIndex];
    }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
    updateVideo(state, payload) {
        updateField(state.video_data[state.currentIndex], payload);
    },

    setCurrentIndexByID(state, theID) {
        state.currentIndex = state.video_data.findIndex(
            video => video.id == theID
        );
    },

    deleteImage(state, payload) {
        let index = state.video_data[state.currentIndex].photos_id.findIndex(
            item => item === payload
        );

        state.video_data[state.currentIndex].photos_id.splice(index, 1);
        console.log(state.video_data[state.currentIndex].photos_id);
    },

    deleteDocument(state, payload) {
        let index = state.fuel_data[state.currentIndex].documents_id.findIndex(
            item => item === payload
        );
        state.video_data[state.currentIndex].documents_id.splice(index, 1);
    },

    loadAllVideos(state, payload) {
        state.video_data = payload.data;
        state.currentIndex = 0;
    },

    addVideo(state, payload) {
        state.video_data.push(payload.data);
        state.currentIndex = state.video_data.length - 1;
    },

    saveVideo(state, payload) {
        state.video_data[state.currentIndex] = payload.data;
    },

    fetchVideo(state, payload) {
        if (state.currentIndex == -1) {
            state.video_data.push(payload.data);
            state.currentIndex = 0;
        } else {
            state.video_data[state.currentIndex] = payload.data;
        }
    },

    deleteVideo(state, payload) {
        state.currentIndex = state.video_data.findIndex(
            video => video.id == payload.data.id
        );
        state.video_data.splice(state.currentIndex, 1);
    },

    cleanForSave(state) {
        state.video_data[state.currentIndex].amount = parseFloat(
            state.video_data[state.currentIndex].amount
        );
    },
    next(state){
        if(state.currentIndex == state.video_data.length-1){
            state.currentIndex = 0;
        }else{
            state.currentIndex += 1;
        }
    },

    previous(state){
        if(state.currentIndex == 0){
            state.currentIndex = state.video_data.length-1;
        }else{
            state.currentIndex -= 1;
        }
    },
    reset(state) {
        state.video_data = []
        state.currentIndex = -1
    },
    initVideoItems(state, ) {
        state.video_data[state.currentIndex].video_items = [];
    }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
    async loadAllVideos({ commit }) {
        try {
            commit("loadAllVideos", await Repository.get(`${VIDEO_API}`));
        } catch (error) {
            console.log(error);
        }
    },

    async addVideo({ commit }) {
        await Repository.get(`${VIDEO_API}/new`)
            .then(response => {
                commit("addVideo", response);
            })
            .catch(error => {
                console.log(error);
            });
    },

    async saveVideo({ state, commit }) {
        try {
            commit("cleanForSave");
            commit(
                "saveVideo",
                await Repository.post(
                    `${VIDEO_API}`,
                    state.video_data[state.currentIndex]
                )
            );
        } catch (error) {
            console.log(error);
        }
    },

    async fetchVideo({ commit }, payloadID) {
        try {
            commit(
                "fetchVideo",
                await Repository.get(`${VIDEO_API}/${payloadID}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async deleteVideo({ commit }, payloadID) {
        console.log(payloadID);
        try {
            commit(
                "deleteVideo",
                await Repository.delete(`${VIDEO_API}/${payloadID}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async searchVideos({ commit }, searchTerm) {
        try {
            commit(
                "loadAllVideos",
                await Repository.get(`${VIDEO_API}/search?q=${searchTerm}`)
            );
        } catch (error) {
            console.log(error);
        }
    }
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
